// El puente entre la ficha de un producto y el formulario de cotización.
//
// Alguien que abre la ficha de un roller blackout y aprieta "Cotizar" ya dijo
// qué quiere. Bajarlo al formulario para que lo vuelva a elegir en un <select>
// es hacerle repetir una decisión que ya tomó, así que la ficha la anuncia acá
// y el formulario la recoge.
//
// Es un ref y no un evento porque el formulario puede montarse después de que
// se pidió: el último pedido queda escrito y se lee cuando toque.
import { ref } from 'vue'

export const requestedProductId = ref(null)

// Un contador para que dos clics seguidos al mismo producto se noten como dos
// pedidos. Sin esto, pedir "roller blackout" dos veces solo cambia el ref la
// primera, y el segundo clic no haría nada visible.
export const requestCount = ref(0)

export function requestQuoteFor (productId) {
  requestedProductId.value = productId ?? null
  requestCount.value += 1

  document.getElementById('cotizar')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
